import { Utilities as utilities } from "@truckdown/framework";
import { ClientRestrictionStatus } from "./ClientRestrictionStatus";
import { RestrictionType } from "./RestrictionType";

export class GetRestrictionsModel {
    constructor(json?: any) {
        if (json) {
            this.type = utilities.json.getEnumValue(json, "t", RestrictionType, RestrictionType.IpAddress);
            this.filter = utilities.json.getStringValue(json, "filter");
            if (json.account) {
                this.account = utilities.json.getNumberValue(json, "account", 0);
            }
            this.category = utilities.json.getStringValue(json, "cat");
            if (json.status) {
                this.status = utilities.json.getEnumValue(json, "status", ClientRestrictionStatus, ClientRestrictionStatus.Active);
            }
            this.start = utilities.json.getDateValue(json, "start");
            this.end = utilities.json.getDateValue(json, "end");

            if (json.lastDate) {
                this.lastDate = utilities.json.getDateValue(json, "lastDate");
            }
            this.lastKey = utilities.json.getStringValue(json, "last");
            this.sortCommand = utilities.json.getStringValue(json, "sort");
            this.take = utilities.json.getNumberValue(json, "take", 15);
        }
    }

    toJSON() {
        return {
            t: this.type,
            filter: this.filter,
            account: this.account,
            cat: this.category,
            status: this.status,
            start: this.start,
            end: this.end,
            lastDate: this.lastDate,
            last: this.lastKey,
            sort: this.sortCommand,
            take: this.take
        };
    }

    type: RestrictionType = RestrictionType.IpAddress;
    filter: string | null = null;

    account: number | null = null;
    category: string | null = null;
    status: ClientRestrictionStatus | null = null;
    start: Date | null = null;
    end: Date | null = null;

    lastDate: Date | null = null;
    lastKey: string | null = null;
    sortCommand: string | null = null;
    take: number = 15;
}